export default __webpack_public_path__ + "static/media/Clan Bound Hauberk of the Far Horizon.e70dac25.jpg";